import React from 'react';
import { Descriptions, Image, Space, Tag, Typography } from 'antd';
import { CatalogItem } from '../../api/productCatalog';
import CardSection from './CardSection';

interface NationalCatalogMetadata {
  good_name?: string;
  good_status?: string;
  manufacturer?: string;
  country?: string;
  image_urls?: string[];
  attributes?: { attr_id?: number; attr_name?: string; attr_value?: string; attr_value_type?: string }[];
}

interface Props {
  item: CatalogItem;
}

const NationalCatalogSection: React.FC<Props> = ({ item }) => {
  const metadata = item.extra_data?.national_catalog as NationalCatalogMetadata | undefined;
  if (!metadata && !item.gtin?.length) return null;
  const attributes = (metadata?.attributes || []).filter(attribute => attribute.attr_value);

  return (
    <CardSection title="Национальный каталог" defaultOpen>
      <Space direction="vertical" size={12} style={{ width: '100%' }}>
        {!!item.gtin?.length && (
          <div>
            <Typography.Text type="secondary">GTIN: </Typography.Text>
            <Space size={4} wrap>{item.gtin.map(gtin => <Tag key={gtin}>{gtin}</Tag>)}</Space>
          </div>
        )}
        {metadata?.good_status && (
          <Tag color={metadata.good_status === 'published' ? 'green' : 'orange'}>
            {metadata.good_status === 'published' ? 'Опубликовано' : metadata.good_status}
          </Tag>
        )}
        {metadata?.image_urls?.[0] && (
          <Image src={metadata.image_urls[0]} alt={metadata.good_name || item.model_name} width={120} style={{ objectFit: 'contain' }} />
        )}
        <Descriptions column={1} size="small" bordered>
          {metadata?.manufacturer && <Descriptions.Item label="Производитель">{metadata.manufacturer}</Descriptions.Item>}
          {metadata?.country && <Descriptions.Item label="Страна">{metadata.country}</Descriptions.Item>}
          {attributes.map((attribute, index) => (
            <Descriptions.Item key={`${attribute.attr_id || attribute.attr_name}-${index}`} label={attribute.attr_name || `Атрибут ${attribute.attr_id || index + 1}`}>
              {attribute.attr_value}{attribute.attr_value_type ? ` ${attribute.attr_value_type}` : ''}
            </Descriptions.Item>
          ))}
        </Descriptions>
      </Space>
    </CardSection>
  );
};

export default NationalCatalogSection;
